import {
	buildQueryString,
	getRoutePath
} from '@sporkbytes/routing';

const entityPathSegment = "accounting";
function connect(axios, body) {
	const config = {
		entityPathSegment,
		additionalPathSegments: ["connect"]
	};

	const routePath = getRoutePath(config);

	return axios.post(routePath, body)
		.then(response => response.data);
}
function getAccounts(axios, queryStringConfig) {
	const config = {
		entityPathSegment,
		additionalPathSegments: ["accounts"],
		queryString: buildQueryString(queryStringConfig)
	};

	const routePath = getRoutePath(config);

	return axios.get(routePath)
		.then(response => response.data);
}
function getContacts(axios, queryStringConfig) {
	const config = {
		entityPathSegment,
		additionalPathSegments: ["contacts"],
		queryString: buildQueryString(queryStringConfig)
	};

	const routePath = getRoutePath(config);

	return axios.get(routePath)
		.then(response => response.data);
}
function getContact(axios, id, queryStringConfig) {
	const config = {
		entityPathSegment,
		additionalPathSegments: ["contacts", id],
		queryString: buildQueryString(queryStringConfig)
	};

	const routePath = getRoutePath(config);

	return axios.get(routePath)
		.then(response => response.data);
}
function getInvoices(axios, queryStringConfig) {
	const config = {
		entityPathSegment,
		additionalPathSegments: ["invoices"],
		queryString: buildQueryString(queryStringConfig)
	};

	const routePath = getRoutePath(config);

	return axios.get(routePath)
		.then(response => response.data);
}
function getInvoice(axios, id, queryStringConfig) {
	const config = {
		entityPathSegment,
		additionalPathSegments: ["invoices", id],
		queryString: buildQueryString(queryStringConfig)
	};

	const routePath = getRoutePath(config);

	return axios.get(routePath)
		.then(response => response.data);
}
function getItems(axios, queryStringConfig) {
	const config = {
		entityPathSegment,
		additionalPathSegments: ["items"],
		queryString: buildQueryString(queryStringConfig)
	};

	const routePath = getRoutePath(config);

	return axios.get(routePath)
		.then(response => response.data);
}
function getOrganization(axios, queryStringConfig) {
	const config = {
		entityPathSegment,
		additionalPathSegments: ["organization"],
		queryString: buildQueryString(queryStringConfig)
	};

	const routePath = getRoutePath(config);

	return axios.get(routePath)
		.then(response => response.data);
}
function validateConnection(axios, queryStringConfig) {
	const config = {
		entityPathSegment,
		additionalPathSegments: ["validate-connection"],
		queryString: buildQueryString(queryStringConfig)
	};

	const routePath = getRoutePath(config);

	return axios.get(routePath)
		.then(response => response.data);
}
export {
	connect,
	getAccounts,
	getContact,
	getContacts,
	getInvoice,
	getInvoices,
	getItems,
	getOrganization,
	validateConnection
};
